import { Form } from 'vee-validate';
import { inject, ref } from 'vue';
import { ReturnFieldComponent } from './returns-common.mjs';

const ReturnsWizardOrderFormComponent = {
	props: {
		email: {
			type: String,
			default: ''
		},
		orderNumber: {
			type: String,
			default: ''
		}
	},
	emits: [
		'orderAvailable'
	],
	setup( props, { emit } ) {

		/** @type {import('./returns-api.mjs').ReturnsApi} **/
		const returnsApi = inject( 'returnsApi' );

		/** @type {import('./returns-translations.mjs').TReturnsTranslate} **/
		const translate = inject( 'translate' );

		const { email: propsEmail, orderNumber: propsOrderNumber } = props;
		const email = ref( propsEmail );
		const orderNumber = ref( propsOrderNumber );

		const isValidOrderNumber = ( value ) =>
			String( value ).trim().match( /^[0-9]{4,}$/ ) ? true : 'Inserisci un numero di ordine valido';

		const formRef = ref( null );
		const submitted = ref( false );
		const submitting = ref( false );
		const error = ref( null );

		const submit = async () => {

			if ( submitting.value )
				return;
			submitting.value = true;
			submitted.value = true;
			error.value = null;

			try {
				const orderRequest = await returnsApi.fetchOrder( orderNumber.value, email.value );
				if ( !orderRequest.success ) {
					submitting.value = false;
					error.value = orderRequest.error;
					return;
				}

				emit( 'orderAvailable', { orderNumber: orderNumber.value, email: email.value, order: orderRequest.data } );
			} catch ( err ) {
				// These are network-level errors.
				console.error( 'An error occurred during order load', err );
				error.value = { code: 'NETWORK_ERROR' };
			}

			submitting.value = false;
		};

		return {
			formRef,
			email,
			orderNumber,
			submit,
			submitted,
			submitting,
			error,
			translate,
			isValidOrderNumber,
		}
	},
	template: `
		<Form v-slot="{ meta }" @submit="submit" ref="formRef">
			<div class="form" :class="{ valid: meta.valid, invalid: !meta.valid, submitted, submitting }">
				<div class="wizard-step-body">
					<div class="flex flex-col gap-4">
						<div v-if="error" class="banner banner--error">
							{{ translate( 'ERRORS.' + error.code, error.parameters ) }}
						</div>
						<div class="input-row">
							<ReturnFieldComponent v-model="orderNumber" type="text" name="orderNumber" :rules="isValidOrderNumber" label="Numero ordine" :validate-on-input="false" :maxlength="10" />
							<ReturnFieldComponent v-model="email" type="text" name="email" rules="required|email" label="Email" :validate-on-input="false" :maxlength="50" />
						</div>
					</div>
				</div>
				<div class="wizard-step-footer py-4">
					<button type="submit" class="button button--primary" :disabled="submitting">
						{{ submitting ? 'Ricerca in corso...' : 'Ricerca' }}
					</button>
				</div>
			</div>
		</Form>
	`,
	components: {
		Form,
		ReturnFieldComponent
	},
}

export default ReturnsWizardOrderFormComponent;
